export default __webpack_public_path__ + "static/evalubox-image-8f963ee70429737138f1474a37b65c91.png";